import { createClient } from '@supabase/supabase-js';
import { config } from './config';

// Single shared Supabase client. We use it ONLY for auth (login + session).
// All data access goes through our /api endpoints, which use the service role
// key server-side and enforce business rules.
export const supabase = createClient(config.supabaseUrl, config.supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
  },
});
